function getAllOptionsAreSamePrice(attributes) {
    for (const attribute of Object.values(attributes)) {
        for (const attributeValue of Object.values(attribute.options)) {
            if (attributeValue.differentialDiscountPrice !== 0) {
                return false;
            }
        }
    }
    return true;
}

export { getAllOptionsAreSamePrice };
//# sourceMappingURL=getAllOptionsAreSamePrice.mjs.map
